export default __webpack_public_path__ + "static/media/placeholder_private01-en-web.b2b86c45.png";